export const recipient_form = {
  number_count: '0 number | {count} number | {count} numbers',
  ['include-dbs']: 'Termasuk Databases',
  ['exclude-dbs']: 'Tidak Termasuk Databases',

  field: {
    number: 'Nomor'
  },

  button: {
    add_recipients: 'Tambah Penerima',
    add_number: 'Tambah Nomor'
  },

  tab: {
    include: {
      title: 'Termasuk Database',
      required_format: 'Database harus dalam format international.'
    },

    exclude: {
      title: 'Tidak Termasuk Database'
    },

    recipient: {
      title: 'Tambah nomor',
      description:
      'Tambahkan 100 nomor di sini. Setiap nomor baru per baris paragrafnya. Nomor harus format international.'
    }
  },

  send: {
    description: 'Surat akan dikirimkan ke',
    cost: 'Biaya Estimatesi {cost}',
    send: 'Send'
  }
};
